import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useVehicleTemplates } from '../../../hooks';
import styles from './VehicleTemplateList.module.css';
import { VehicleType } from '../../../types/model/vehicle.model';

export const VehicleTemplateList: React.FC = () => {
    const navigate = useNavigate();
    const {
        templates,
        loadTemplates,
        isLoading,
        removeTemplate
    } = useVehicleTemplates();

    useEffect(() => {
        loadTemplates();
    }, [loadTemplates]);

    const handleDelete = async (e: React.MouseEvent, id: string) => {
        e.preventDefault();
        e.stopPropagation();
        if (window.confirm('¿Estás seguro de que deseas eliminar este template?')) {
            await removeTemplate(id);
        }
    };

    const handleEdit = (e: React.MouseEvent, id: string) => {
        e.preventDefault();
        e.stopPropagation();
        navigate(`/vehicle-templates/edit/${id}`);
    }

    if (isLoading) {
        return (
            <div className={styles.inventoryContainer}>
                <div className={styles.loading}>
                    <div className={styles.spinner}></div>
                    <p>Cargando templates...</p>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.inventoryContainer}>
            <div className={styles.header}>
                <div>
                    <h4>Mis Plantillas</h4>
                    <p>Gestiona tus modelos predefinidos de vehículos</p>
                </div>
                <Link to="/vehicle-templates/create" className={styles.addButton}>
                    ➕ Crear Plantilla
                </Link>
            </div>

            {templates.length > 0 ? (
                <div className={styles.vehicleGrid}>
                    {templates.map((template) => (
                        <div
                            key={template.id}
                            className={styles.vehicleCard}
                            onClick={() => navigate(`/vehicle-templates/edit/${template.id}`)}
                            style={{ cursor: 'pointer' }}
                        >

                            <div className={styles.vehicleInfo}>
                                <div className={styles.vehicleHeader}>
                                    <h3>
                                        <span className={styles.smallIcon}>
                                            {template.vehicleType === VehicleType.MOTO ? '🏍️' :
                                                template.vehicleType === VehicleType.CAMION ? '🚛' :
                                                    template.vehicleType === VehicleType.CAMIONETA ? '🚙' : '🚗'}
                                        </span>
                                        {template.name}
                                    </h3>
                                    <span className={`${styles.badge} ${styles[template.condition]}`}>
                                        {template.condition}
                                    </span>
                                </div>
                                <div className={styles.vehicleDetails}>
                                    <p><strong>Vehículo:</strong> {template.brand} {template.model} {template.year}</p>
                                    <p><strong>Color:</strong> {template.color}</p>
                                    <p><strong>Motor:</strong> {template.engine}</p>
                                </div>
                                <div className={styles.vehicleFooter}>
                                    <div className={styles.footerTop}>
                                        <span className={styles.price}>
                                            {template.currency === 'USD' ? 'USD' : '$'} {template.price.toLocaleString('es-AR')}
                                        </span>
                                        <div className={styles.actions}>
                                            <button
                                                className={styles.actionButton}
                                                onClick={(e) => handleEdit(e, template.id)}
                                                title="Editar"
                                            >
                                                ✏️
                                            </button>
                                            <button
                                                className={styles.actionButton}
                                                onClick={(e) => handleDelete(e, template.id)}
                                                title="Eliminar"
                                                style={{ color: '#e74c3c' }}
                                            >
                                                🗑️
                                            </button>
                                        </div>
                                    </div>
                                    <div className={styles.dates}>
                                        <small>Creado: {new Date(template.createdAt).toLocaleDateString()}</small>
                                        {template.updatedAt !== template.createdAt && (
                                            <small>Modif: {new Date(template.updatedAt).toLocaleDateString()}</small>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className={styles.emptyState}>
                    <div className={styles.emptyIcon}>📝</div>
                    <h2>No hay plantillas creadas</h2>
                    <p>Crea tu primera plantilla para agilizar la carga de vehículos</p>
                    <Link to="/vehicle-templates/create" className={styles.emptyButton}>
                        ➕ Crear Primer Template
                    </Link>
                </div>
            )}
        </div>
    );
};
